import React from 'react';
import { useTranslation } from 'react-i18next';

const ICONS = [
    // Clock / waiting
    <svg key="1" width="22" height="22" fill="none" viewBox="0 0 22 22">
        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 6v5l3.5 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    // Loop / rework
    <svg key="2" width="22" height="22" fill="none" viewBox="0 0 22 22">
        <path d="M4 11a7 7 0 0111.5-5.4M18 11a7 7 0 01-11.5 5.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M15 3v3h-3M7 19v-3h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    // Phone / no answer
    <svg key="3" width="22" height="22" fill="none" viewBox="0 0 22 22">
        <rect x="6" y="2" width="10" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9.5 17h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M8.5 8.5l5 4M13.5 8.5l-5 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>,
];

const ProblemCard = ({ icon, title, description }) => (
    <div className="flex flex-col gap-4 p-6 rounded-2xl bg-gray-800/40 border border-gray-700/50">
        <div className="w-11 h-11 rounded-xl bg-red-500/10 border border-red-500/20
                    flex items-center justify-center text-red-400/80 shrink-0">
            {icon}
        </div>
        <div className="flex flex-col gap-2">
            <h3 className="text-white font-semibold text-base">{title}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">{description}</p>
        </div>
    </div>
);

const ProblemSection = () => {
    const { t } = useTranslation();
    const items = t('problem.items', { returnObjects: true });

    return (
        <section className="py-24 bg-gray-950 border-t border-gray-900">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                <div className="text-center mb-14">
          <span className="inline-block text-red-500/70 text-xs font-bold tracking-widest uppercase mb-3">
            {t('problem.label')}
          </span>
                    <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4 max-w-2xl mx-auto leading-tight">
                        {t('problem.title')}
                    </h2>
                    <p className="text-gray-400 text-lg">
                        {t('problem.subtitle')}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
                    {items.map((item, i) => (
                        <ProblemCard
                            key={i}
                            icon={ICONS[i]}
                            title={item.title}
                            description={item.description}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProblemSection;
